import React from "react";
import { withRouter } from "react-router";
import NavBar from "../../../components/common/navbar";
import SideBar from "../../../components/modules/left_sidebar";
import MarcasCommon from "./MarcasCommon";
import Footer from "../../../components/common/Footer";

const optionMenuArray = {
    linkData: {
        filters: {
            Tabs: {
                Marca: [
                    {
                        key: "Código de Marca",
                        displayKey: "Código de Marca",
                        inputType: "text",
                    },
                    {
                        key: "Nome de Marca",
                        displayKey: "Nome de Marca",
                        inputType: "text",
                    },
                ],
                Entidade: [
                    // {
                    //     key: "Numero de Entidade",
                    //     displayKey: "Numero de Entidade",
                    //     inputType: "text",
                    // },
                    {
                        key: "Nome de Entidade",
                        displayKey: "Nome de Entidade",
                        inputType: "text",
                    },
                ],
                // Data: [
                //     {
                //         key: "RangePicker",
                //         displayKey: "Data de Submissão",
                //         inputType: "RangePicker",
                //     },
                //     {
                //         key: "RangePicker",
                //         displayKey: "Data de Validação",
                //         inputType: "RangePicker",
                //     },
                // ],
            },
            checkbox: [],
        },
        tableName: "MarcasApproved",
        TitleBartitle: "Lista de Marcas",
        prevPageName: "Lista de Marcas",
        prevPageLink: "/marcasApproved",
        currentPath: "marcasApproved",
    },
};

class MarcasApproved extends React.Component {
    constructor(props) {
        super(props);
        this.state = { ...optionMenuArray };
    }
    componentDidMount() {}
    render() {
        return (
            <div className="dashboard">
                <NavBar
                    date={new Date()}
                    linkData={this.state.linkData}
                    noOption={true}
                    moduleName="Marcas"
                />
                <SideBar Administration={false} />
                <MarcasCommon
                    linkData={this.state.linkData}
                    tableName={this.state.linkData.tableName}
                />
                <Footer />
            </div>
        );
    }
}

export default withRouter(MarcasApproved);
